import { render, staticRenderFns } from "./TableBox.vue?vue&type=template&id=f5d611e4"
import script from "./TableBox.vue?vue&type=script&lang=js"
export * from "./TableBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f5d611e4')) {
      api.createRecord('f5d611e4', component.options)
    } else {
      api.reload('f5d611e4', component.options)
    }
    module.hot.accept("./TableBox.vue?vue&type=template&id=f5d611e4", function () {
      api.rerender('f5d611e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/basic/TableBox.vue"
export default component.exports